import { schema } from 'normalizr'

// User schema for normalization
export const userSchema = new schema.Entity('users')
